<template>
  <div id="app">
    <router-view></router-view>
    <div class="main" v-title data-title="Q-NEX管理后台">
    </div>
  </div>
</template>
<script>
  export default{
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue